export default __webpack_public_path__ + "static/media/cancel.d2a0406d.svg";